$ = require 'jquery'
React = require 'react'
Label = require 'models/label'
ModelCache = require 'db/model-cache'
Controller = require 'controller'
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'
t = require 'recup'

CARD_PREVIEW_NARROW = 248
CARD_PREVIEW_WIDE = 360
CARD_DEFAULT_HEIGHT = 156
CARD_HEIGHT_OFFSET = -87
CARD_WIDTH_OFFSET = -7
CARD_LEFT_OFFSET = 20

module.exports = class CalendarCardPreview extends React.Component
  displayName: 'Calendar Card Preview'
  wideMode: false

  calculateNewCoords: (coords) ->
    if (coords.top == 0 && coords.left == 0)
      return {
        top: 0
        left: 0
      }
    wrapperDim = $('.calendar-wrapper').get(0).getBoundingClientRect()

    if @props.viewMode == 'day'
      @wideMode = true
      cardWidth = CARD_PREVIEW_WIDE
      top = coords.bottom - wrapperDim.top + 1
      left = coords.left + CARD_WIDTH_OFFSET

      if (wrapperDim.bottom - coords.bottom) < CARD_DEFAULT_HEIGHT
        bottom = coords.height + wrapperDim.bottom - coords.bottom + 1

      if (wrapperDim.width - coords.left) < cardWidth
        right = wrapperDim.width - coords.right - CARD_WIDTH_OFFSET

    else
      @wideMode = false
      cardWidth = CARD_PREVIEW_NARROW
      top = coords.top - wrapperDim.top
      left = coords.right + CARD_WIDTH_OFFSET

      if (wrapperDim.bottom - coords.bottom) < CARD_DEFAULT_HEIGHT
        bottom = wrapperDim.bottom - coords.bottom

      if (wrapperDim.width - coords.right + CARD_WIDTH_OFFSET) < cardWidth
        right = wrapperDim.width - coords.right + coords.width + CARD_WIDTH_OFFSET + CARD_LEFT_OFFSET

    if bottom && right
      return { bottom, right }
    if bottom && !right
      return { bottom, left }
    if !bottom && right
      return { top, right }

    { top, left }

  render: t.renderable ->
    t.div '.nc-card-preview',
      {
        style: @calculateNewCoords @props.cardBeingPreviewedCoords
      },
      =>
        if @props.isCardPreviewOn
          card = @props.cardBeingPreviewed
          if card.id
            numNotifications = ModelCache.find('Notification', (notification) =>
              notification.get('unread') &&
              notification.get('data')?.card?.id == card.id
            ).length
            t.tag CanonicalCard, {
              board: card.getBoard()
              card: card
              labels: card.getLabels().sort(Label.compare)
              lightBackground: true
              list: card.getList()
              members: card.memberList.models
              numNotifications
              organization: card.getBoard().getOrganization()
              onCardClick: (e) =>
                e.preventDefault()
                @props.hidePreview()
                Controller.showCardDetail card
              onCardMouseEnter: (e) =>
                @props.cancelCardPreviewLeaveTimer()
              onCardMouseLeave: (e) =>
                @props.hidePreview()
              showListNameOnly: true
              wideMode: @wideMode
            }



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-card-preview.coffee